import { render } from "./CategoryNavigation.vue?vue&type=template&id=22e6f6b4&scoped=true"
import script from "./CategoryNavigation.vue?vue&type=script&lang=js"
export * from "./CategoryNavigation.vue?vue&type=script&lang=js"

import "./CategoryNavigation.vue?vue&type=style&index=0&id=22e6f6b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e6f6b4"]])

export default __exports__